interface SupportMessageProps {
  show: boolean;
}

export const SupportMessage = ({ show }: SupportMessageProps) => {
  if (!show) return null;
  
  return (
    <div className="mt-2 text-sm text-muted-foreground">
      <p>Having trouble resetting your password?</p>
      <p className="mt-1">
        Contact{" "}
        <a 
          href="mailto:product@strykr.ai" 
          className="text-blue-500 hover:text-blue-400 hover:underline"
        >
          product@strykr.ai
        </a>
        {" "}for assistance.
      </p>
    </div>
  );
};